<template>
    <div class="animated fadeIn h-100 m-4">
      <CRow>
        <CCol sm="12">
          <CCard>
              <CCardHeader>Poles</CCardHeader>
              <CCardBody>
                <CDataTable
                :hover="true"
                :striped="true"
                :items="poles"
                :fields="fields"
                table-filter
                pagination
                >
                  <template #device="{item}"><td><CLink @click="openDevice(item, true)">{{item.device}}</CLink></td></template>
                  <template #time="{item}"><td>{{formatDate(item.time)}}</td></template>
                  <template #event="{item}"><td>{{item.event == null ? 'N/A' : item.event }}</td></template>
                  <template #tags="{item}"><td><CBadge v-for="(m, index) in item.tags" :color="'info'" class="mr-1">{{m}}</CBadge></td></template>
                  <template #tiltx="{item}"><td>{{item.config == null ? '' : Math.round((item.tiltx - ((item.config !== null && item.config.tiltx !== undefined ? item.config.tiltx : 0)))*10)/10}}</td></template>
                  <template #tiltz="{item}"><td>{{item.config == null ? '' : Math.round((item.tiltz - ((item.config !== null && item.config.tiltz !== undefined ? item.config.tiltz : 0)))*10)/10}}</td></template>
                </CDataTable>
              </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="9">
          <CCard>
            <CCardHeader>Map</CCardHeader>
            <CCardBody>
              <gmap-map :center="center" :zoom="zoom" ref="mapa" map-type-id="roadmap" style="width: 100%; min-height: 378px;">
                <!--gmap-cluster :grid-size="gridSize" v-if="clustering" v-on:click="clustering=false">
                  <gmap-custom-marker v-if="view=='asset' || view=='world'" :key="index" v-for="(m, index) in markers" :marker="m.position" :clickable="true" @click.native="openDevice(m)" :title="m.devicename" style="margin-top: 16px;"><div class="mapMarker"><i :class="markerClass(m.event)" /></div></gmap-custom-marker>
                </gmap-cluster-->
                <gmap-custom-marker v-if="clustering==false" :key="index" v-for="(m, index) in poles" :marker="m.position" :clickable="true" @click.native="openDevice(m, false)" :title="m.devicename" style="margin-top: 16px;"><div class="mapMarker"><i :class="markerClass(m.event)" /></div></gmap-custom-marker>
              </gmap-map>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol sm="3">
          <CCard>
              <CCardHeader>Inclination</CCardHeader>
              <CCardBody>
                <div id="canvasContainer" style="width: 100%; position: relative; padding-top: 100%;" class="mb-2">
                  <canvas id="deviceOrientation" style="width: 100%; height: 100%; border:1px solid #000000; position: absolute; top: 0; left: 0; bottom: 0; right: 0;"></canvas>
                </div>
                <div class="text-center w-100">
                  <CButton color="info" shape="pill" :disabled="this.currentPole == null" @click="deviceLock()">Device Position Lock</CButton>
                </div>
              </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CCard>
              <CCardHeader>Events</CCardHeader>
              <CCardBody>
                <CTabs>
                  <CTab v-if="inclinationcollection.datasets[0].data.length > 0" title="Inclination">
                    <LineChart ref="inclinationChart" :chart-data="inclinationcollection" :options="tempChartOptions" :height="100"></LineChart>
                  </CTab>
                  <CTab v-if="temperaturecollection.datasets[0].data.length > 0" title="Temperature">
                    <LineChart ref="tempChart" :chart-data="temperaturecollection" :options="tempChartOptions" :height="100"></LineChart>
                  </CTab>
                  <CTab v-if="batterycollection.datasets[0].data.length > 0" title="Battery">
                     <LineChart ref="battChart" :chart-data="batterycollection" :options="tempChartOptions" :height="100"></LineChart>
                  </CTab>
                  <CTab v-if="poleEvents.length > 0" title="Events">
                    <CDataTable
                      :hover="true"
                      :striped="true"
                      :items="poleEvents"
                      :fields="eventFields"
                      table-filter
                      pagination
                      >
                        <template #time="{item}"><td>{{formatDate(item.time)}}</td></template>
                        <template #event="{item}"><td>{{item.event == null ? 'N/A' : item.event }}</td></template>
                        <template #tiltx="{item}"><td>{{Math.round(item.tiltx*10)/10}}</td></template>
                        <template #tilty="{item}"><td>{{Math.round(item.tilty*10)/10}}</td></template>
                        <template #tiltz="{item}"><td>{{Math.round(item.tiltz*10)/10}}</td></template>
                      </CDataTable>
                  </CTab>
                </CTabs>
              </CCardBody>
          </CCard>
        </CCol>
      </CRow>
  </div>
</template>

<script>
import Vue from 'vue'
import LineChart from './charts/LineChart.js'
import VueSlider from 'vue-slider-component'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import 'vue-slider-component/theme/antd.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import { telemetry } from '@/api'
import store from "@/store"

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD8vswyC9F9G4rpJnpfpgZAwL4J0C-FhO4',
    libraries: 'places'
  }
})

Vue.component('GmapCluster', GmapCluster)

export default {
  name: 'Poles',
  components: {
      'gmap-custom-marker': GmapCustomMarker,
      VueSlider,
      LineChart,
      datePicker
  },
  data () {
    return {
      center: {lat: 48, lng: 18},
      zoom: 9,
      //poles: [],
      fields: ['device', {key: 'devicename', label: 'Name'}, {key: 'time', label: 'Last event'}, 'event', 'tags', 'tiltx', 'tiltz'],
      eventFields: [{key: 'time', label: 'Time'}, 'event', {key: 'lqi', label: 'Signal'}, 'tiltx', 'tilty', 'tiltz', 'voltage', 'temperature'],
      device: 'Device',
      deviceName: 'Device',
      temperaturecollection: {
        datasets: [{label: "Temperature", backgroundColor: '#39f', borderColor: '#39f', type: 'line', lineTension: 0, pointRadius: 0, fill:false, data: []}]
      },
      batterycollection: {
        datasets: [{label: "Battery", backgroundColor: '#39f', borderColor: '#39f', type: 'line', lineTension: 0, pointRadius: 0, fill:false, data: []}]
      },
      inclinationcollection: {
        datasets: [{label: "X axis", backgroundColor: '#39f', borderColor: '#39f', type: 'line', lineTension: 0, pointRadius: 0, fill:false, data: []},
                   {label: "Y axis", backgroundColor: '#40d640', borderColor: '#40d640', type: 'line', lineTension: 0, pointRadius: 0, fill:false, hidden:true, data: []},
                   {label: "Z axis", backgroundColor: '#ff3333', borderColor: '#ff3333', type: 'line', lineTension: 0, pointRadius: 0, fill:false, data: []}]
      },
      timeFormat: 'MM/DD/YYYY HH:mm:ss a',
      tempChartOptions: {
        scales: {
            xAxes: [{
                type: 'time',
                distribution: 'series',
                time: {
                  unit: 'hours',
                  //stepSize: 3, // I'm using 3 hour intervals here
                  tooltipFormat: 'DD.MM.YYYY - HH:mm:ss',
                  displayFormats: {
                    hours: 'DD.MM - HH:mm'
                  }
                }
            }]
        },
        plugins: {
          datalabels: {
            display: false
          }
        }
      },
      //markers: [],
      currentMarker: 0,
      poleEvents: [],
      paths: [],
      pathsLoaded: [],
      InfoWindowShown: false,
      clustering: false,
      hideLowAcc: true,
      gridSize: 50,
      view: "world",
      dateFrom: this.startOfDay(this.previous2weeks(new Date())),
      dateTo: this.endOfDay(new Date()),
      options: {
        useCurrent: false,
        locale: 'sk'
      },
      sliderOptions: {
        min: 0,
        max: 1,
        interval: 1,
      },
      timestampFormater: v => (this.pathsLoaded.length>0?this.formatDate(this.pathsLoaded[this.pathsLoaded.length - v - 1].time):'')
    }
  },
  computed: {
    path() {
      return this.$router.history.current.fullPath
    },
    currentPole () {
      return this.$store.state.currentDevice
    },
    poles () {
      return this.$store.state.poles
    }
  },
  watch: {
    $route(to, from) {
      this.updateMap()
    },
    currentPole: function(prev, now) {
      /*
      for(var idx=0; idx < this.poles.length; idx++) {
        if(this.poles[idx].device == this.currentPole.device) {
          this.poles[idx].time = this.currentPole.time
          this.poles[idx].event = this.currentPole.event
          this.poles[idx].tiltx = this.currentPole.tiltx
          this.poles[idx].tilty = this.currentPole.tilty
          this.poles[idx].tiltz = this.currentPole.tiltz
          break
        }
      }
      */
      this.redraw(true)
    }
  },
  mounted () {
    this.updateMap()
    this.redraw(false)
  },
  methods: {
    deviceLock () {
      var that = this
      telemetry.updateDevice({id: this.currentPole.device, config: {tiltx: this.currentPole.tiltx, tilty: this.currentPole.tilty, tiltz: this.currentPole.tiltz}})
        .then(response => {
        this.$toasted.success('Device Locked.')
        that.updateMap()
      }).catch((error) => {
        this.$toasted.error('Unable to save device.')
      })
    },
    previous2weeks (date) {
      date.setDate(date.getDate() - 14)
      return date
    },
    startOfDay (date) {
      date.setHours(0,0,0,0)
      return date
    },
    endOfDay (date) {
      date.setHours(23,59,59,999)
      return date
    },
    redraw (inclination) {
      var dlX = 0
      var dlZ = 0

      if(this.currentPole !== null && this.currentPole.config !== undefined) {
        if(this.currentPole.config.tiltx !== undefined) dlX = this.currentPole.config.tiltx
        if(this.currentPole.config.tiltz !== undefined) dlZ = this.currentPole.config.tiltz
      }

      var container = document.getElementById('canvasContainer')
      var c = document.getElementById('deviceOrientation')
      var ctx = c.getContext('2d')

      c.width = container.offsetWidth
      c.height = container.offsetHeight
      var width = c.width
      var height = c.height

      ctx.clearRect(0, 0, width, height)
      ctx.beginPath()
      ctx.arc(width / 2 + (dlX / 90 * ((width / 2) - width / 15) * -1), height / 2 + (dlZ / 90 * ((height / 2) - width / 15)), width / 15, 0, 2 * Math.PI)
      ctx.closePath()
      ctx.stroke()

      ctx.beginPath()
      ctx.arc(width / 2, height / 2, width / 2.1, 0, 2 * Math.PI)
      ctx.closePath()
      ctx.stroke()

      ctx.beginPath()
      ctx.moveTo(width / 2, height * 0.025)
      ctx.lineTo(width / 2, height - (height * 0.025))
      ctx.moveTo(width * 0.025, height / 2)
      ctx.lineTo(width - width * 0.025, height / 2)
      ctx.closePath()
      ctx.stroke()

      ctx.beginPath()
      if(inclination && this.currentPole.tiltx !== null && this.currentPole.tiltz !== null) {
        if (Math.abs(dlX - this.currentPole.tiltx) <= 3 && Math.abs(dlZ - this.currentPole.tiltz) <= 3) {
          ctx.fillStyle = '#00FF00'
        } else {
          ctx.fillStyle = '#FF0000'
        }

        ctx.arc(width / 2 + (this.currentPole.tiltx / 90 * ((width / 2) - width / 30) * -1), height / 2 + (this.currentPole.tiltz / 90 * ((height / 2) - width / 30)), width / 30, 0, 2 * Math.PI)
        ctx.fill()
      }
    },
    markerClass (event, temperature) {
      if(temperature < -5) {
        return "fa fa-snowflake-o"
      }
      switch(event) {
        case "open_full":
        case "open_one_tape":
        case "open_one_button":
        case "cap_released":
        case "disarmed":
        case "heartbeat_open":
              return "fa fa-envelope-open-o"
        case "sealed":
        case "sealed_recovered":
        case "armed":
        case "heartbeat_sealed":
              return "fa fa-envelope-o"
        case "stop": return "fa fa-hourglass-o"
        case "tracing": return "fa fa-truck"
        case "start": return "fa fa-arrows"
        case "heartbeat": return "fa fa-heartbeat"
      }
      return "fa fa-gear"
    },
    openDevice(dev, panto) {
      this.$store.dispatch("changeDevice", dev).then(() => {
        if(panto) {
          this.$refs.mapa.$mapPromise.then((map) => {
            map.panTo(dev.position)
          })
        }
        telemetry.pole_telemetry(this.currentPole.device).then(response => {
          this.poleEvents = []
          var newTemp = Object.assign({},this.temperaturecollection)
          var newBattery = Object.assign({},this.batterycollection)
          var newInclination = Object.assign({},this.inclinationcollection)

          newTemp.datasets[0].data = []
          newBattery.datasets[0].data = []
          newInclination.datasets[0].data = []
          newInclination.datasets[1].data = []
          newInclination.datasets[2].data = []

          if(response.data !== undefined && response.data.length > 0) {
            this.poleEvents = response.data
            for(var idx=0; idx < response.data.length; idx++) {
              if(response.data[idx].tiltx != null) newInclination.datasets[0].data.push({t: response.data[idx].time*1000, y: response.data[idx].tiltx})
              if(response.data[idx].tilty != null) newInclination.datasets[1].data.push({t: response.data[idx].time*1000, y: response.data[idx].tilty})
              if(response.data[idx].tiltz != null) newInclination.datasets[2].data.push({t: response.data[idx].time*1000, y: response.data[idx].tiltz})
              if(response.data[idx].temperature !== null) newTemp.datasets[0].data.push({t: response.data[idx].time*1000, y: response.data[idx].temperature})
              if(response.data[idx].voltage !== null) newBattery.datasets[0].data.push({t: response.data[idx].time*1000, y: response.data[idx].voltage})
            }
          }
          this.temperaturecollection = newTemp
          this.inclinationcollection = newInclination
          this.batterycollection = newBattery
        })
      })
    },
    formatDate(date) {
      return (new Date(date*1000)).toLocaleString()
    },
    updateMap() {
      var that = this
      this.$refs.mapa.$mapPromise.then(() => {
        this.$store.dispatch("loadPoles").then(() => {
        })
        /*
        telemetry.poles().then(response => {
          if(response.data !== undefined && response.data.length > 0) {
            this.poles = response.data
            this.markers = response.data
            if(this.currentPole !== null) {
              for(var idx = 0; idx < this.poles.length; idx++) {
                if(that.poles[idx].device == that.currentPole.device) {
                  //ToDo that.currentPole = that.poles[idx]
                  break
                }
              }
              that.openDevice(that.currentPole, false)
            }
          }
        })
        */
      })

      /*
      this.$refs.mapa.$mapPromise.then(() => {
        var fullPath = this.$router.history.current.fullPath
        if(fullPath.startsWith("/world/asset/")) {
          this.view = "asset"
            this.device = this.$router.history.current.fullPath.substring(13,this.$router.history.current.fullPath.length)
            var filter = {hideLowAccuracy: this.hideLowAcc}
            //if(this.$refs.dateFrom!==undefined) console.log(this.$refs.dateFrom.$options)
            if(this.dateFrom !== null && this.dateFrom != '') filter.dateFrom = Math.round(Date.parse(this.dateFrom)/1000)
            if(this.dateTo !== null && this.dateTo != '') filter.dateTo = Math.round(Date.parse(this.dateTo)/1000)
            telemetry.devicePositions(this.device, filter).then(response => {
              if(response.data !== undefined && response.data.length > 0) {
                this.markers = [ response.data[0] ] //response.data
                var path = []
                var bounds = new google.maps.LatLngBounds();
                for(var idx=0; idx < response.data.length; idx++) {
                  if(response.data[idx].position !== undefined && response.data[idx].position.lat !== null && response.data[idx].position.lng !== null) {
                    path.push({lat: response.data[idx].position.lat, lng: response.data[idx].position.lng, time: response.data[idx].time, event: response.data[idx].event})
                    bounds.extend({lat: response.data[idx].position.lat, lng: response.data[idx].position.lng})
                  }
                }
                this.sliderOptions.max = path.length - 1
                this.currentMarker = path.length - 1
                this.paths = path
                this.pathsLoaded = path
                this.$refs.mapa.$mapObject.fitBounds(bounds)
              }
            }).catch((error) => {
              this.$toasted.error(error)
            })
        } else {
          this.view = "world"
          telemetry.lastPositions().then(response => {
            if(response.data !== undefined) {
              this.markers = response.data
              console.log(this.markers)
              var bounds = new google.maps.LatLngBounds();
              for(var idx=0; idx < this.markers.length; idx++) {
                if(response.data[idx].position !== undefined && response.data[idx].position.lat !== null && response.data[idx].position.lng !== null) {
                    bounds.extend(this.markers[idx].position)
                }
              }
              this.$refs.mapa.$mapObject.fitBounds(bounds)
            }
          }).catch((error) => {
            this.$toasted.error(error)
          })
        }
      })
      */
    }
  }
}
</script>
